import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 60px;
  padding: 10px;
  gap: 80px;
`;


export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 50px;
`;

export const ImageContainer = styled.div`
  @media only screen and (min-width: 1000px) {
    display: flex;
    gap: 100px;
    .hr{
    
    height: 400px;
  }
  }
  @media only screen and (min-width: 750px) and (max-width: 1000px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 100px;
    .hr{
        display: none;
    }
  }
  @media only screen and (min-width: 250px) and (max-width: 750px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 50px;
    .hr{
        display: none;
    }
  }
  
`;


export const Text = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 10px;
`

export const Title = styled.h1`
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 2em;
  color: #1485c7;
`;

export const Paragraph = styled.p`
  font-size: 18px;
  font-weight: bold;
  max-width: 400px;
`;

export const Images = styled.div`
  margin-bottom: 100px;
`;
